



import { Component, Prop } from 'vue-property-decorator';
import SaascadaVue from '@/components/Shared/SaascadaVue';
import WalletState from '@/models/Accounts/DepositAccounts/Wallets/WalletState';

@Component({ name: 'WalletState' })
export default class extends SaascadaVue {

    @Prop({ required: true })
    state: WalletState;

    get textColor() {
        let color = "";
        switch (this.state) {
            case WalletState.Active:
                color = "body-2 success--text";
                break;
            case WalletState.Closed:
                color = "body-2 error--text";
                break;
        }
        return color;
    }
}
